import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import Table, { dateFormatter, buttonsStyle } from '../../../components/tables/table'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'
import { getTickets, deleteTicket, updateTicket } from '../../../../api/ticket'
import {
  Button,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'
import {
  mapCitasRows,
  filterCitasTickets,
} from './ticketTableUtils'

export default function CitasPage() {
  const [data, setData] = useState([])
  const [ticketId, setTicketId] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [statusFilter, setStatusFilter] = useState('')
  const [serviceFilter, setServiceFilter] = useState('')
  const [dateFrom, setDateFrom] = useState('')
  const [dateTo, setDateTo] = useState('')
  const [search, setSearch] = useState('')
  const history = useHistory()

  function reloadList() {
    setRefresh(true)
  }

  function quickStatus(id, status) {
    updateTicket(id, { status })
      .then((res) => {
        if (res.status === 200) {
          alertSuccess({
            title: 'Actualizado',
            customMessage: status === 'in_progress' ? 'Cita confirmada.' : 'Cita cancelada.',
          })
          reloadList()
        }
      })
      .catch((error) => {
        alertError({ error, customMessage: 'No se pudo actualizar la cita.' })
      })
  }

  function buttonFormatter(cell, row) {
    const status = row.statusRaw
    const canConfirm = status === 'pending'
    const canCancel = status === 'pending' || status === 'in_progress'

    return (
      <>
        {canConfirm && (
          <Tooltip title="Confirmar">
            <Button style={buttonsStyle} size="small" onClick={() => quickStatus(cell, 'in_progress')}>
              <CheckCircleIcon />
            </Button>
          </Tooltip>
        )}
        {canCancel && (
          <Tooltip title="Cancelar cita">
            <Button style={buttonsStyle} size="small" onClick={() => quickStatus(cell, 'cancelled')}>
              <CancelIcon />
            </Button>
          </Tooltip>
        )}
        <Tooltip title="Edit">
          <Button style={buttonsStyle} size="small" onClick={() => history.push('/edit-cita/' + cell)}>
            <EditIcon />
          </Button>
        </Tooltip>
        <Tooltip title="Delete">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setTicketId(cell)
              setOpenConfirmDialog(true)
            }}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      </>
    )
  }

  const columns = [
    { dataField: 'ref', text: 'Ref', sort: true },
    { dataField: 'serviceName', text: 'Servicio', sort: true },
    { dataField: 'site', text: 'Sitio / centro', sort: true },
    { dataField: 'dateTime', text: 'Fecha / Hora', sort: true },
    { dataField: 'status', text: 'Estado', sort: true },
    { dataField: 'email', text: 'Email', sort: true },
    { dataField: 'createdAt', text: 'Creado', formatter: dateFormatter, sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter },
  ]

  useEffect(() => {
    const params = { kind: 'appointment' }
    if (statusFilter) params.status = statusFilter
    getTickets(params)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data)
          setRefresh(false)
        }
      })
      .catch((error) => {
        alertError({ error, customMessage: 'No se pudieron cargar las citas.' })
      })
  }, [refresh, statusFilter])

  const filtered = useMemo(
    () =>
      filterCitasTickets(data, {
        service: serviceFilter,
        dateFrom,
        dateTo,
        search,
      }),
    [data, serviceFilter, dateFrom, dateTo, search],
  )

  return (
    <Card>
      <CardHeader title="Citas previas" />
      <CardBody>
        <div style={{ display: 'flex', gap: 16, marginBottom: 16, flexWrap: 'wrap' }}>
          <FormControl variant="outlined" size="small" style={{ minWidth: 160 }}>
            <InputLabel>Estado</InputLabel>
            <Select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              label="Estado"
            >
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="pending">Pendiente</MenuItem>
              <MenuItem value="in_progress">Confirmada</MenuItem>
              <MenuItem value="resolved">Completada</MenuItem>
              <MenuItem value="cancelled">Cancelada</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="Servicio"
            size="small"
            variant="outlined"
            value={serviceFilter}
            onChange={(e) => setServiceFilter(e.target.value)}
            style={{ minWidth: 160 }}
          />
          <TextField
            label="Desde"
            type="date"
            size="small"
            variant="outlined"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
            InputLabelProps={{ shrink: true }}
            style={{ minWidth: 150 }}
          />
          <TextField
            label="Hasta"
            type="date"
            size="small"
            variant="outlined"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
            InputLabelProps={{ shrink: true }}
            style={{ minWidth: 150 }}
          />
          <TextField
            label="Buscar (ref, email, nombre…)"
            size="small"
            variant="outlined"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ minWidth: 220 }}
          />
        </div>
        <Table data={mapCitasRows(filtered)} columns={columns} />
        <ConfirmDialog
          title="¿Eliminar esta cita?"
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deleteTicket(ticketId)
              .then((res) => {
                if (res.status === 200 || res.status === 204) {
                  alertSuccess({ title: 'Eliminado', customMessage: 'Cita eliminada.' })
                  reloadList()
                }
              })
              .catch((error) => {
                alertError({ error, customMessage: 'No se pudo eliminar.' })
              })
          }}
        />
      </CardBody>
    </Card>
  )
}
